"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharMatcher = exports.ANY_CHAR = exports.DIGIT_CHAR = exports.PRE_NEWLINE = exports.POST_NEWLINE = exports.getNextStateId = void 0;
var NextStateId = 0;
function getNextStateId() {
    return NextStateId++;
}
exports.getNextStateId = getNextStateId;
exports.POST_NEWLINE = -1;
exports.PRE_NEWLINE = -2;
exports.DIGIT_CHAR = -3;
exports.ANY_CHAR = -4;
/**
  When the match function is called, it will return true if the argument
  matches a particular character.

  @constructor
 */
var CharMatcher = /** @class */ (function () {
    function CharMatcher(mchar) {
        this.mchar = mchar;
    }
    CharMatcher.prototype.match = function (ch) {
        //dbg.printf("Compare %s with %s\n", this.mchar, ch );
        if (this.mchar == exports.DIGIT_CHAR) {
            return ch >= '0' && ch <= '9';
        }
        else if (this.mchar == exports.ANY_CHAR) {
            return ch !== exports.POST_NEWLINE && ch !== exports.PRE_NEWLINE && ch != '\n';
        }
        else {
            return ch == this.mchar;
        }
    };
    CharMatcher.prototype.toString = function () {
        if (this.mchar == exports.DIGIT_CHAR) {
            return '\\d';
        }
        else {
            return this.mchar;
        }
    };
    return CharMatcher;
}());
exports.CharMatcher = CharMatcher;
//# sourceMappingURL=CharMatcher.js.map